import React from 'react';
import PropTypes from 'prop-types';
import Input from '@bufferapp/ui/Input';
import SearchIcon from '@bufferapp/ui/Icon/Icons/Search';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  width: 100%;
  margin: 7px 0px 15px 0px;
`;

const ProfileSearch = ({ onSearchProfileChange, searchText }) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <Input
        type="input"
        size="tall"
        icon={<SearchIcon color="gray" />}
        onChange={(event) => {
          onSearchProfileChange(event.target.value);
        }}
        value={searchText || ''}
        name="profile-sidebar-search-profiles"
        placeholder={t('profile-sidebar.searchProfiles')}
      />
    </Wrapper>
  );
};

ProfileSearch.propTypes = {
  onSearchProfileChange: PropTypes.func.isRequired,
  searchText: PropTypes.string,
};

ProfileSearch.defaultProps = {
  searchText: '',
};

export default ProfileSearch;
